"use strict";'use strict';

var chunkGF2WI4RG_js = require('./chunk-GF2WI4RG.js');
require('./chunk-2TWZWBQO.js');



module.exports = chunkGF2WI4RG_js.Visa_default;
